import { Component, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, FormGroup,ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';

// PrimeNG Components
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { MessageModule } from 'primeng/message';
import { Validators } from '@angular/forms';
import { LoginService } from './login.service';
import { LoginDto } from './dto/login.dto';
import { ToastService } from '../../common/services/toast.service';
import { FormValidationErrorService } from '../../common/services/form-validation-error.service';
import { AuthService } from '../../common/services/auth.service';

//TODO: need to add errors to internationalisation <- need to think this may be later
const VALIDATION_MESSAGES: Record<string, Record<string, string>> = {
  username: {
    required: 'Username is required',
    email: 'Invalid email format',
    minlength: 'Username must be at least 5 characters',
  },
  password: {
    required: 'Password is required',
    minlength: 'Password must be at least 8 characters',
  },
};

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    CommonModule,
    InputTextModule,
    PasswordModule,
    ButtonModule,
    CardModule,
    MessageModule,
    ReactiveFormsModule,
  ],
  templateUrl: './login.html',
  styleUrl: './login.css',
  providers: [LoginService]
})
export class LoginComponent {
  loading = signal(false);
  loginFormGroup = new FormGroup({
      username: new FormControl('',[Validators.required, Validators.minLength(5),Validators.email]),
      password: new FormControl('',[Validators.required, Validators.minLength(8)])
  })
  constructor(
    private router: Router,
    private loginService: LoginService,
    private toastService: ToastService,
    private formValidationErrorService: FormValidationErrorService,
    private authService: AuthService
  ) {
    this.authService.logout(); // Clear auth state on login page
  }
  
  async onLogin() {
    this.loginFormGroup.markAllAsTouched();
    if(this.loginFormGroup.valid){
      this.loading.set(true);
      const loginDto: LoginDto = this.loginFormGroup.value as LoginDto;
      try{
        const loginData = await this.loginService.login(loginDto);
        localStorage.setItem('access_token', loginData.accessToken);
        this.authService.login();
        this.router.navigate(['/home'])
      }catch(e:any){
        this.toastService.show({
          severity:'error',
          summary:'Error',
          detail:'Please check username/password or contact Relias-DE Tech Support.'
        })
      } finally{
        this.loading.set(false);
      }
    }else{
        const errors = this.formValidationErrorService.getFormValidationErrors(this.loginFormGroup,VALIDATION_MESSAGES);
        this.toastService.show({
          severity: 'error',
          summary: 'Validation Error',
          detail: errors.join(', ')
        });
    } 
    
  }
    
}
